import Dashboard from './Dashboard'

const ops =  {
    dashboard: Dashboard
};

export default ops;